module.exports = __webpack_public_path__ + "images/multibanco.c6a3d6af2173370f726bd174f46c4ea7.svg";